import { render, staticRenderFns } from "./ContentExpand.vue?vue&type=template&id=05eab0d0&scoped=true&"
import script from "./ContentExpand.vue?vue&type=script&lang=js&"
export * from "./ContentExpand.vue?vue&type=script&lang=js&"
import style0 from "./ContentExpand.vue?vue&type=style&index=0&id=05eab0d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eab0d0",
  null
  
)

export default component.exports